import { render, staticRenderFns } from "./OrderItemLinkAttachment.vue?vue&type=template&id=0ca49d7e"
import script from "./OrderItemLinkAttachment.vue?vue&type=script&lang=js"
export * from "./OrderItemLinkAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports